import React, { useState } from "react";
import { motion } from "framer-motion";
import "./TestimonialsSlider.css";

// DATA
const TESTIMONIALS = [
    {
        quote: "Absolutely loved the silver pendant I ordered from Avnii – the shine, finish, and detailing are far better than what I expected at this price",
        name: "Ananth P",
        // location: "Seattle, Washington",
    },
    {
        quote: "Avnii’s designs feel modern yet traditional, perfect for daily wear as well as functions. The piece looks even better in real life than in the photos.",
        name: "Shruthi",
        // location: "Portland, Oregon",
    },
    {
        quote: "Excellent customer support – they patiently answered my questions about care, polishing, and sizing. Overall, a very smooth and trustworthy experience",
        name: "Vikas",
        // location: "Bangalore, India",
    },
    {
        quote: "The oxidised silver piece I picked has such intricate craftsmanship. It has that handcrafted feel with a very refined finish.",
        name: "Suhail",
        // location: "New Mexico",
    },
];

const wrapIndex = (i, len) => (i + len) % len;

// ANIMATION VARIANTS
const cardVariants = {
    center: {
        x: "-50%",
        scale: 1,
        opacity: 1,
        zIndex: 3,
        filter: "blur(0px)",
        transition: { duration: 0.6, ease: "easeInOut" }
    },
    left: {
        x: "-95%",
        scale: 0.9,
        opacity: 0.45,
        zIndex: 2,
        filter: "blur(2px)",
        transition: { duration: 0.6, ease: "easeInOut" }
    },
    right: {
        x: "-5%",
        scale: 0.9,
        opacity: 0.45,
        zIndex: 2,
        filter: "blur(2px)",
        transition: { duration: 0.6, ease: "easeInOut" }
    },
    hidden: {
        opacity: 0,
        scale: 0.8,
        x: 0,
        zIndex: 1
    }
};

export default function TestimonialsSlider() {
    const [index, setIndex] = useState(0);
    const total = TESTIMONIALS.length;

    const next = () => setIndex((i) => wrapIndex(i + 1, total));
    const prev = () => setIndex((i) => wrapIndex(i - 1, total));

    return (
        <section className="tm-wrapper">
            <h2 className="tm-title">What Clients Talk About Us</h2>

            <div className="tm-slider">

                {/* LEFT ARROW */}
                <button className="tm-arrow tm-arrow-left" onClick={prev}>‹</button>

                <div className="tm-stage">

                    {TESTIMONIALS.map((t, i) => {
                        const pos = wrapIndex(i - index, total);

                        let state = "hidden";
                        if (pos === 0) state = "center";
                        else if (pos === 1) state = "right";
                        else if (pos === total - 1) state = "left";

                        return (
                            <motion.div
                                key={i}
                                className="tm-card"
                                variants={cardVariants}
                                animate={state}
                                initial={false}
                            >
                                <p className="tm-quote">“{t.quote}”</p>
                                <p className="tm-name">{t.name}</p>
                                <p className="tm-location">{t.location}</p>
                            </motion.div>
                        );
                    })}

                </div>

                {/* RIGHT ARROW */}
                <button className="tm-arrow tm-arrow-right" onClick={next}>›</button>

            </div>

            {/* MOBILE ARROWS */}
            <div className="tm-mobile-arrows">
                <button className="tm-arrow tm-arrow-mobile" onClick={prev}>‹</button>
                <button className="tm-arrow tm-arrow-mobile" onClick={next}>›</button>
            </div>

        </section>
    );
}
